import {
  faCss3,
  faGitAlt,
  faHtml5,
  faJs,
  faNode,
  faReact,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import Loader from "react-loaders";
import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";

const About = () => {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              arr={["A", "b", "o", "u", "t", " ", "M", "e"]}
              index={15}
            />
          </h1>
          <p>
            Hi, I’m Brian Oh. I am hard working Full Stack Developer having an
            experience in building web and mobile applications using JavaScript,
            React, React Native, Nodejs, Express and many backend database
            programs.
          </p>
          <p>
            I am a team player who values responsibility. I had multiple
            opportunities to collaborate with peers during coding Bootcamp.
            Every time when a task was given, I successfully finished my task
            even if I had to work extra hours. Also, I continuously asked my
            teammates what they are working on to get a full understanding of
            the project and was happy to help them if needed.
          </p>
          <p>
            Also, I am self driven person who likes to build and learn new
            technologies to achieve my goal. Whenever i face difficulties, I
            brave it through the challenges and successfully finish the task.
          </p>
        </div>
        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faHtml5} />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faCss3} />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faReact} />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faNode} />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJs} />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} />
            </div>
          </div>
        </div>
      </div>
      <Loader type="ball-pulse" />
    </>
  );
};

export default About;
